import { loadTranslations } from "$lib/translations";

export const load = async ({ params, url }) => {
	const { pathname } = url;

	const initLocale = ["en", "fr"].includes(params.lang!) ? params.lang : "en";

	await loadTranslations(initLocale!, pathname); // keep this just before the `return`

	return {};
};
